// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2363":"c1e2dcb3","2594":"2e538a9e","3321":"e5c04ab8","4652":"902f0503","8571":"567b3964"}[chunkId] + ".chunk.css";
};